import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=0134eed6&scoped=true&lang=pug&"
import script from "./CompanyPage.vue?vue&type=script&lang=js&"
export * from "./CompanyPage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPage.vue?vue&type=style&index=0&id=0134eed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134eed6",
  null
  
)

export default component.exports